// these are now populated from EPAT API
// but keeping this in here for reference
const appliancesForEapt = {
  space_heating: [
    'Electric, Efficiency 100%',
    '13 SEER /8.1 HSPF Heat Pump',
    '14 SEER /8.4 HSPF Heat Pump',
    '15 SEER /8.8 HSPF Heat Pump',
    '16 SEER /9.0 HSPF Heat Pump',
    '18 SEER /9.2 HSPF Heat Pump',
    '20.5 SEER /13 HSPF Heat Pump',
    'Natural Gas, AFUE 80%',
    'Natural Gas, AFUE 90%',
    'Natural Gas, AFUE 92%',
    'Natural Gas, AFUE 94%',
    'Natural Gas, AFUE 96%',
    'Natural Gas, AFUE 98%',
    '1.4 AFUE Natural Gas Absorption Heat Pump (Prototype)',
    'Propane, AFUE 80%',
    'Propane, AFUE 82%',
    'Propane, AFUE 90%',
    'Propane, AFUE 92%',
    'Propane, AFUE 94%',
    'Propane, AFUE 96%',
    '1.4 AFUE Propane Absorption Heat Pump (Prototype)',
    '1.2 COP Natural Gas Engine Heat Pump (Prototype)',
    '1.2 COP Propane Engine Heat Pump (Prototype)'
  ],
  water_heating: [
    'Electric Resistance EF, 0.88',
    'Electric Resistance EF, 0.90',
    'Electric Resistance EF, 0.95',
    'Electric Heat Pump EF, 2.00',
    'Electric Heat Pump EF, 2.20',
    'Electric Heat Pump EF, 2.40',
    'Electric Heat Pump EF, 3.25',
    'Electric Heat Pump EF, 3.45',
    'Natural Gas EF 1.30 - Absorption Heat Pump',
    'Natural Gas EF 0.95 - Condensing Tankless',
    'Natural Gas EF 0.84 - Non-Condensing Tankless',
    'Natural Gas EF 0.82 - Modulating Condensing Storage',
    'Natural Gas EF 0.75 - Condensing Storage',
    'Natural Gas EF 0.67 - Energy Star Storage',
    'Natural Gas EF 0.62 - Min. Eff. Storage',
    'Propane EF 1.30 - Absorption Heat Pump',
    'Propane EF 0.95 - Condensing Tankless',
    'Propane EF 0.84 - Non-Condensing Tankless',
    'Propane EF 0.82 - Modulating Condensing Storage',
    'Propane EF 0.75 - Condensing Storage',
    'Propane EF 0.67 - Energy Star Storage',
    'Propane EF 0.62 - Min. Eff. Storage'
  ],
  cooking_range: [
    'Electric Standard EF 0.74',
    'Electric Induction EF 0.84',
    'Gas Standard',
    'Propane Standard'
  ],
  clothes_dryer: [
    'Electric Standard EF 3.1',
    'Electric Standard EF 3.93',
    'Gas Standard EF 2.75',
    'Gas Standard EF 3.84',
    'Propane Standard EF 2.75'
  ]
};

export const epatTableFields = {
    so2: 'SO2 (lb)',
    nox: 'NOx (lb)',
    co2: 'CO2 (1000 lb)',
    ch4: 'CH4 (lb)',
    n2o: 'N2O (lb)',
    co2e: 'CO2e (1000 lb)'
  };

export const houseTypeOptions = [
    'Mobile',
    'Single Fam Detached',
    'Single Fam Attached',
    'Apt Building 2-4 units',
    'Apt Building 5+ units'
  ];

/**
 * Determine which options we need to return from appliancesForEapt
 * based on which appliances have been added to the project
 *
 * @param {array} appliances
 * @param {array} equipmentOptions
 * @returns {array} optionsToReturn
 */
const applianceToOptionsMapping = (appliances) => {
  const optionsToReturn = [];
  const mappings = {
    ['Space Heating']: [
      'appliance_furnace',
      'appliance_hydronic_air_handler',
      'appliance_hybrid_heat_pump',
      'appliance_boiler'
    ],
    ['Water Heating']: [
      'appliance_boiler',
      'appliance_combi_boiler',
      'appliance_water_heater'
    ],
    ['Cooking Range']: ['appliance_cooktop_range'],
    ['Clothes Dryer']: ['appliance_clothes_dryer']
  };

  appliances.forEach((appliance) => {
    for (const mappingKey in mappings) {
      if (mappings[mappingKey].includes(appliance)) {
        optionsToReturn.push(mappingKey);
      }
    }
  });

  return optionsToReturn;
};

/**
 * Return options for Epat appliances
 * @param {object} projectData
 * @param {array} equipmentOptions
 * @return {object} applianceOptions
 */
export const getApplianceOptions = (projectData, equipmentOptions) => {
  const applianceOptions = {};
  const appliances = Object.keys(projectData)
    .filter((key) => key.startsWith('appliance_'))
    .filter(
      (key) =>
        key !== 'appliance_attestation' && key !== 'appliance_total_incentives'
    )
    .filter((key) => !key.endsWith('_changed_from'))
    .filter((key) => Boolean(parseInt(projectData[key])));

  const options = applianceToOptionsMapping(appliances);

  options.forEach((option) => {
    const matchingEquipment = equipmentOptions.find(equipment => equipment.equipmentName === option);
    applianceOptions[option] = matchingEquipment ? {equipmentId: matchingEquipment.id, options: matchingEquipment.efficiencies}: {};
  });

  return applianceOptions;
};
